/**
 * Module Store - Verwaltet den Enable/Disable-Status von Modulen
 */

import { create } from "zustand"

interface ModuleState {
  enabledModules: string[]
  isLoaded: boolean

  setEnabledModules: (modules: string[]) => void
  isModuleEnabled: (slug: string) => boolean
}

export const useModuleStore = create<ModuleState>()((set, get) => ({
  enabledModules: [],
  isLoaded: false,

  setEnabledModules: (modules) =>
    set({ enabledModules: modules, isLoaded: true }),

  isModuleEnabled: (slug) => {
    const { enabledModules, isLoaded } = get()
    // Bevor Module geladen sind: alles erlauben
    if (!isLoaded) return true
    return enabledModules.includes(slug)
  },
}))
